<template>
  <div class="bg-light border-right p-3" style="width: 300px; flex-shrink: 0; overflow-y: auto;">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="m-0">{{ $t("common.filter") }}</h5>
      <b-button variant="link" size="sm" class="p-0 text-decoration-none" @click="resetFilters">
        {{ $t("common.reset") }}
      </b-button>
    </div>

    <h5 class="mt-4">{{ $t("compliance-item.compliance") }}</h5>
    <!-- <hr /> -->
    <!-- Compliance (Root) -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("compliance-item.compliance") }}</label>
      <b-form-select :value="filters.compliance" size="sm" @change="onComplianceSelect">
        <option value="">{{ $t("common.all") }}</option>
        <option v-for="opt in complianceList" :key="opt" :value="opt">{{ opt }}</option>
      </b-form-select>
    </div>

    <!-- Compliance Group -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("compliance-item-group.text") }}</label>
      <filter-select
        id="complianceGroupFilter"
        ref="complianceGroupFilter"
        :placeholder="$t('common.select')"
        :selected="filters.complianceGroup"
        @filter="onComplianceGroupSearch"
        @changed="onComplianceGroupSelect"
      >
      </filter-select>
    </div>

    <!-- Compliance Item No -->
    <!-- <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("compliance-item.no") }}</label>
      <input type="text" class="form-control form-control-sm" :value="filters.complianceItemNo" @input="updateFilter('complianceItemNo', $event.target.value)" />
    </div> -->

    <div class="form-group mb-2">
      <label>{{ $t("compliance-item.no") }}</label>
      <!-- <input class="form-control " v-model="noFilter" /> -->
      <filter-select
        id="complianceItemNoFilter"
        ref="complianceItemNoFilter"
        :placeholder="$t('compliance-item.no')"
        :multiple="false"
        :selected="filters.complianceItemNo"
        openDirection="bottom"
        @filter="complianceItemNoSearch"
        @changed="complianceItemNoSelect"
        track="name"
      />
    </div>

    <!-- Compliance Item Search -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("compliance-item.name") }}</label>
      <input type="text" class="form-control form-control-sm" :value="filters.complianceItemSearch" @input="updateFilter('complianceItemSearch', $event.target.value)" />
    </div>

    <!-- Compliance Item Description -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("compliance-item.description") }}</label>
      <input type="text" class="form-control form-control-sm" :value="filters.complianceItemDescription" @input="updateFilter('complianceItemDescription', $event.target.value)" />
    </div>

    <h5 class="mt-4">{{ $t("audit-control.control.text-2") }}</h5>
    <!-- Control No -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("audit-control.control.no") }}</label>
      <input type="text" class="form-control form-control-sm" :value="filters.no" @input="updateFilter('no', $event.target.value)" />
    </div>

    <!-- Control Name -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("audit-control.control.name") }}</label>
      <input type="text" class="form-control form-control-sm" :value="filters.name" @input="updateFilter('name', $event.target.value)" />
    </div>

    <!-- Control Category -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("audit-control.control.category") }}</label>
      <filter-select :placeholder="$t('common.select')" :selected="filters.category" @filter="onControlCategorySearch" @changed="onControlCategorySelect"> </filter-select>
    </div>

    <!-- Control Type -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("audit-control.control.type") }}</label>
      <filter-select :placeholder="$t('common.select')" :selected="filters.type" @filter="onControlTypeSearch" @changed="onControlTypeSelect"> </filter-select>
    </div>
    <!-- Control Status -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("audit-control.control.status") }}</label>
      <b-form-select :value="filters.status" size="sm" @change="updateFilter('status', $event)">
        <option :value="undefined">{{ $t("common.all") }}</option>
        <option value="ACTIVE">{{ $t("audit-control.status.active") }}</option>
        <option value="COMPLETED">{{ $t("audit-control.status.completed") }}</option>
        <option value="PASSIVE">{{ $t("audit-control.status.passive") }}</option>
      </b-form-select>
    </div>

    <!-- Control Criticality -->
    <div class="form-group mb-2">
      <label class="font-weight-bold small mb-1">{{ $t("audit-control.control.criticality") }}</label>
      <b-form-checkbox-group :checked="filters.criticalities" stacked class="pl-1" @change="updateFilter('criticalities', $event)">
        <b-form-checkbox value="LOW">{{ $t("audit-control.criticality.low") }}</b-form-checkbox>
        <b-form-checkbox value="MEDIUM">{{ $t("audit-control.criticality.medium") }}</b-form-checkbox>
        <b-form-checkbox value="HIGH">{{ $t("audit-control.criticality.high") }}</b-form-checkbox>
        <b-form-checkbox value="CRITICAL">{{ $t("audit-control.criticality.critical") }}</b-form-checkbox>
      </b-form-checkbox-group>
    </div>
  </div>
</template>

<script>
import { Compliances } from "@/modules/core/compliances/compliances";

export default {
  name: "AuditControlFilterSidebar",
  components: {},
  data() {
    return {
      complianceList: Compliances,
    };
  },
  computed: {
    filters() {
      return this.$store.getters["organizationControl/controlFilters"] || {};
    },
  },
  methods: {
    onComplianceSelect(value) {
      this.updateFilter("compliance", value);
      this.$refs.complianceItemNoFilter.reset();
      this.$refs.complianceGroupFilter.reset();
    },
    async complianceItemNoSearch(value, callback) {
      const queryValue = { $regex: `.*${value}.*`, $options: "i" };

      const response = await this.$store.dispatch(`libraryComplianceItem/paginateForSearch`, {
        options: { limit: 200, sort: { no: "asc" } },
        query: { ...(this.filters.compliance ? { compliance: { value: this.filters.compliance, isObject: true } } : {}), no: { value: queryValue, isObject: true } },
      });

      const options = response.data?.docs.map((i) => ({ name: { tr: i.no, en: i.no, de: i.no, fr: i.no } })) ?? [];

      options.sort((a, b) => (a.name.tr || "").localeCompare(b.name.tr || "", undefined, { numeric: true, sensitivity: "base" }));

      callback(options);
    },
    complianceItemNoSelect(value) {
      this.updateFilter("complianceItemNo", value || null);
    },
    updateFilter(key, val) {
      const newFilters = { ...this.filters, [key]: val };
      this.$store.commit("organizationControl/controlFilters", newFilters);
      // Emit event to notify parent to trigger search (debounce)
      this.$emit("input", newFilters);
    },
    resetFilters() {
      const emptyFilters = {
        no: "",
        name: "",
        category: null,
        criticalities: [],
        type: null,
        compliance: "",
        complianceGroup: null,
        complianceItemNo: null,
        complianceItemSearch: "",
        complianceItemDescription: "",
        status: undefined,
      };
      this.$store.commit("organizationControl/controlFilters", emptyFilters);
      this.$emit("input", emptyFilters);
      this.$emit("reset");

      if (this.$refs.complianceItemNoFilter) {
        this.$refs.complianceItemNoFilter.reset();
      }
      if (this.$refs.complianceGroupFilter) {
        this.$refs.complianceGroupFilter.reset();
      }
    },
    async onControlTypeSearch(value, callback) {
      const response = await this.$store.dispatch(`libraryControlType/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: {
          // "scope.value": { value: "system", isObject: true },
          name: { value },
        },
      });
      callback(response.data?.docs ?? []);
    },
    onControlTypeSelect(item) {
      if (item) {
        this.updateFilter("type", item);
      } else {
        this.updateFilter("type", null);
      }
    },
    async onComplianceGroupSearch(value, callback) {
      // Need to fetch via libraryComplianceItemGroup
      const response = await this.$store.dispatch(`libraryComplianceItemGroup/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: { ...(this.filters.compliance ? { compliances: { value: this.filters.compliance, isObject: true } } : {}), name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onComplianceGroupSelect(item) {
      if (item) {
        this.updateFilter("complianceGroup", item);
      } else {
        this.updateFilter("complianceGroup", null);
      }
    },
    async onControlCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`libraryControlCategory/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: {
          // "scope.value": { value: "system", isObject: true },
          name: { value },
        },
      });
      callback(response.data?.docs ?? []);
    },
    onControlCategorySelect(item) {
      if (item) {
        this.updateFilter("category", item);
      } else {
        this.updateFilter("category", null);
      }
    },
  },
};
</script>

<style scoped>
/* Custom scrollbar for sidebar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
</style>
